import * as React from "react";
import Footer, { IFooterProps } from "~/components/footer/footer";
import { IFooterBottomProps } from "~/components/footer/footer-bottom/footer-bottom";

export interface IFooterViewProps {
    contextModel: {
        labels: {
            footerBottomCopyrightLabel: IFooterBottomProps["footerBottomCopyrightLabel"];
        };
        footerLogoUrl: IFooterProps["footerLogoUrl"];
        footerLogoImgSrc: IFooterProps["footerLogoImgSrc"];
        footerLogoImgAlt: IFooterProps["footerLogoImgAlt"];
        footerLogoTitle?: IFooterProps["footerLogoTitle"];
        footerContent: IFooterProps["footerContent"];
        footerBottomLinks: IFooterBottomProps["footerBottomLinks"];
        isSignupFlow?: boolean;
    };
}

class FooterView extends React.PureComponent<IFooterViewProps> {
    public render() {
        const { labels } = this.props.contextModel;
        return <Footer {...labels} {...this.props.contextModel} />;
    }
}

export default FooterView;
